import * as streams from './streams';
import {isIOS} from "./device-detect";

function insert(container, mode, html, beforeInsert, afterInsert) {
    let newElement = document.createElement('div');
    newElement.innerHTML = html.trim();
    beforeInsert(mode, html);
    if (mode === 'prepend') {
        container.firstElementChild.after(newElement);
    } else {
        container.insertBefore(newElement, container.lastElementChild);
    }
    afterInsert(mode, newElement);
    return newElement;
}

export const lazyList = function(options) {
    options = Object.assign({}, {
        insertMode: 'append'
    }, options || {});
    let chunks = [];
    let xhr = new XMLHttpRequest();
    let _insert = (html) => {
        return insert(options.container, options.insertMode, html, options.beforeInsert, options.afterInsert);
    };
    xhr.open('GET', options.url);
    xhr.setRequestHeader('Accept', 'image/webp, */*');
    streams.handleStream(xhr, {
        onChunk: (chunk) => {
            chunk = JSON.parse(chunk);
            if (chunk.html) {
                chunks.push(chunk);
                options.onChunk(chunk);
            }
        },
        onDone: () => options.onDone()
    });
    xhr.send();
    return {
        insertNext: () => {
            let nextChunk = chunks.shift();
            if (nextChunk) {
                return _insert(nextChunk.html);
            }
        },
        insert: (code) => {
            chunks = chunks.reduce((newChunks, chunk) => {
                if (chunk.code === code) {
                    return _insert(chunk.html);
                } else {
                    newChunks.push(chunk);
                }
                return newChunks;
            }, []);
        },
        insertAll: () => {
            let allHtml = chunks.reverse().reduce((allHtml, chunk) => {
                return allHtml + chunk.html;
            }, '');
            chunks = [];
            return _insert(allHtml);
        },
        abort: () => xhr.abort(),
        isLoaded: (code) => chunks.filter((chunk) => chunk.code === code).length !== 0,
        finished: () => xhr.readyState === XMLHttpRequest.DONE
    };
}

export const taxonList = function(beforeInsert, afterInsert, deferred = undefined) {
    let options = $(this).data('lazy-list-options');
    let loader = $(this).find('.taxon-prefetch-loader');
    let insertionScheduled = false;
    let pauseInsertion = false;
    options.container = this[0];
    options.beforeInsert = beforeInsert;
    options.afterInsert = afterInsert(() => {
        pauseInsertion = false;
    });
    options.onChunk = (chunk) => {
        if (options.insertMode === 'append') {
            controls.insertAll();
        } else if (
            options.insertMode === 'prepend' &&
            !pauseInsertion && // insertion is paused until after insert callback finishes
            !isIOS()
        ) {
            if (!pauseInsertion) {
                // the upper taxon list must not render before first lower taxon is rendered
                // because when it does, it jumps quite a bit from the top (scroll jump in all major browsers)
                if (deferred && deferred.state() !== 'resolved') {
                    if (!insertionScheduled) {
                        deferred.done(() => {
                            controls.insertAll();
                        });
                    }
                    insertionScheduled = true;
                } else {
                    controls.insertAll();
                }
            }
            pauseInsertion = true;
        }
    }
    options.onDone = () => {
        // the upper taxon list must not render before first lower taxon is rendered
        // because when it does, it jumps quite a bit from the top (scroll jump in all major browsers)
        if (deferred && deferred.state() !== 'resolved') {
            if (!insertionScheduled) {
                deferred.done(() => {
                    controls.insertAll();
                })
            }
            insertionScheduled = true;
        } else {
            controls.insertAll();
        }
        loader.hide();
    }
    let controls = lazyList(options);
    document.addEventListener('app.lazy-list.abort-loading', () => controls.abort());

    return {
        isLoaded: controls.isLoaded,
        insertAll: controls.insertAll,
        abort: controls.abort
    }
}
